import { render, staticRenderFns } from "./BaseGeneralReports.vue?vue&type=template&id=d7d5187a&scoped=true"
import script from "./BaseGeneralReports.vue?vue&type=script&lang=js"
export * from "./BaseGeneralReports.vue?vue&type=script&lang=js"
import style0 from "./BaseGeneralReports.vue?vue&type=style&index=0&id=d7d5187a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d5187a",
  null
  
)

export default component.exports